import { Timer } from './Timer';

// The platform's `setTimeout` and `setInterval`, each returning its canceller.
// Callers take `timer: Timer = systemTimer` so a spec can pass a `FakeTimer`.
export class SystemTimer implements Timer {
  setTimeout(callback: () => void, delayMs: number): () => void {
    const timeout = setTimeout(callback, delayMs);

    return function cancel() {
      clearTimeout(timeout);
    };
  }

  setInterval(callback: () => void, intervalMs: number): () => void {
    const interval = setInterval(callback, intervalMs);

    return function stop() {
      clearInterval(interval);
    };
  }
}

export const systemTimer = new SystemTimer();
